import { NavLink } from "react-router-dom";
import { IconCheck } from '@tabler/icons-react';
export default function InvitationType(props) {
    return (
        <div className="col-md-6 col-xl-3">
            <div className="feat_property">
                <div className="thumb">
                    <img className="img-whp" src={props.evnetType.thumbnailPath} alt="" />
                </div>
                <div className="details text-center">
                    <div className="tc_content">
                        <h4 className="mb-3">{props.evnetType.name}</h4>
                        <NavLink to={"/create-invitation/themes/" + props.evnetType.id}>
                            <button className="btn btn-sm btn-primary px-3 mb-3">
                                <IconCheck className="me-1" size={20} />
                                <span className="align-middle">Select & Proceed</span>
                            </button>
                        </NavLink>
                    </div>
                </div>
            </div>
        </div>
    );
}